import { render } from "./NBboxDistances.vue?vue&type=template&id=00140a6b&ts=true"
import script from "./NBboxDistances.vue?vue&type=script&lang=ts"
export * from "./NBboxDistances.vue?vue&type=script&lang=ts"

import "./NBboxDistances.vue?vue&type=style&index=0&id=00140a6b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__